<template>

    <div>
        <!--相簿-->
        <template v-if="'/location0111' === this.$route.path ">
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data01[0].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="javascript:;" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0211' === this.$route.path ">
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data02[1].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="javascript:;" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>
        
        <template v-if="'/location0212' === this.$route.path ">
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data02[2].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="javascript:;" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul> 
        </template>  


        <template v-if="'/location0221' === this.$route.path ">        
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data02[3].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0312' === this.$route.path ">      
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data03[1].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0313' === this.$route.path "> 
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data03[2].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0314' === this.$route.path ">             
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data03[3].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>  
        </template>         

        <template v-if="'/location0411' === this.$route.path "> 
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data04[0].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0422' === this.$route.path ">                        
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data04[2].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>  


        <template v-if="'/location0512' === this.$route.path "> 
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data05[2].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template> 

        <template v-if="'/location0521' === this.$route.path ">             
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data05[3].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template> 

        <template v-if="'/location0522' === this.$route.path ">             
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data05[4].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0531' === this.$route.path ">              
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data05[5].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0542' === this.$route.path "> 
            <ul class="album-list" id="lightgallery">
                <li  v-for="(photo) in this.data05[6].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0551' === this.$route.path ">             
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data05[7].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0561' === this.$route.path ">             
            <ul class="album-list" id="lightgallery" >
                <li  v-for="(photo) in this.data05[8].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>

        <template v-if="'/location0541' === this.$route.path ">             
            <ul class="album-list" id="lightgallery-coffee">
                <li  v-for="(photo) in this.data05[9].imgList.items" :key="photo.id" :data-src="PicturePath(photo.img)">
                    <a href="#" class="graphic-link">
                        <div class="graphic-img">
                            <img :src="PicturePath(photo.img)">
                        </div>
                    </a>
                </li>
            </ul>
        </template>


    

            
    </div>



                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
</template>




<script>

import $ from 'jquery';
import * as PANOLENS from 'panolens'


    export default {
        data() {
            return {
   
            };
        },
         watch: {

         },
        methods: {

            // 圖片
            PicturePath(id) {
                if( id === null  )
                {
                    return `./default.png`; 
                }
                else 
                {
                    return `./images/${id}`;
                }
            },

        },
        beforeMount(){
  


        },
        mounted: function () {


        },

    }
</script>